// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.addnew-profile,
.addnew-profile-couple {
  padding: 5px;
  width: 100px;
  height: 100px;
  border-radius: 50%;
  text-align: center;
}
.Add-button {
  justify-content: space-between;
  margin: auto;
}
.ant-table-thead .ant-table-cell {
  background-color: #0883b3;
}
.addnew-profile-image {
  display: flex;
  justify-content: center;
}
.form-label {
  padding: 10px;
}
FF .select-width {
  width: 100%;
  padding: 10px;
}
.calender-responsive,
.responsive-select,
.register-input {
  width: 100%;
}
.select-table-row,
.button-tools,
.search-button-table {
  margin-top: 0.8rem;
  margin-bottom: 0.8rem;
}
.Button-Tool {
  display: flex;
  justify-content: space-evenly;
}
.Header-row {
  justify-content: space-between;
  margin: auto;
}
.search-btn {
  width: 80%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 50px;
  margin-top: 10px;
}
.register-button {
  width: 98%;
  display: flex;
  justify-content: center;
}
.btn-cancel {
  margin-right: 10px;
}
.csv-btn {
  margin-top: -30px;
}
.button-row {
  float: right;
}
.patient-edit-image {
  width: 10%;
}
.view-patient-details {
  font-size: medium;
  padding: 1%;
  font-weight: 300;
}
.view-patient-details-label {
  font-size: medium;
}
.flex-end {
  display: flex;
  justify-content: end;
}
.view-header {
  font-weight: 500 !important;
  font-size: large !important;
}
.header-tag {
  margin-bottom: 0 !important;
}
@media only screen and (min-width: 320px) {
  .header-tag {
    font-size: 21px;
    font-weight: 500;
  }
  .addnew-button {
    display: flex;
    justify-content: center;
  }
  .search-button-table {
    width: 100%;
  }
  .select-table-row {
    width: 100%;
  }
  .search-btn {
    width: 100%;
    margin-left: 0;
    margin-bottom: 0.8rem;
  }
  .button-edit {
    padding: 3px;
  }
  .register-button {
    margin-top: 16px;
  }
  .button-row {
    width: 100%;
  }
}
@media only screen and (min-width: 375px) {
  .header-tag {
    font-size: 21px;
    font-weight: 500;
  }
  .addnew-button {
    display: flex;
    justify-content: center;
  }
  .search-button-table {
    width: 100%;
  }
  .select-table-row {
    width: 100%;
  }
  .search-btn {
    width: 100%;
    margin-left: 0;
    margin-bottom: 0.8rem;
  }
  .button-row {
    width: 100%;
  }
}
@media only screen and (min-width: 425px) {
  .header-tag {
    font-size: 21px;
    font-weight: 500;
  }
  .addnew-button {
    display: flex;
    justify-content: center;
  }
  .search-button-table {
    width: 100%;
  }
  .select-table-row {
    width: 100%;
  }
  .search-btn {
    width: 100%;
    margin-left: 0;
    margin-bottom: 0.8rem;
  }
  .button-row {
    width: 100%;
  }
}
@media only screen and (min-width: 768px) {
  .header-tag {
    font-size: 21px;
    font-weight: 500;
  }
  .addnew-button {
    display: flex;
    justify-content: flex-end;
  }
  .search-button-table {
    width: 100%;
  }
  .select-table-row {
    width: 50%;
  }
  .search-btn {
    margin-top: 0.8rem;
  }
  .register-button {
    display: flex;
    justify-content: flex-end !important;
  }
}
@media only screen and (min-width: 1024px) {
  .header-tag {
    font-size: 21px;
    font-weight: 500;
  }
  .addnew-button {
    display: flex;
    justify-content: flex-end;
  }
  .select-table-row {
    width: 60%;
  }
  .search-button-table {
    width: 100%;
  }
}
@media only screen and (min-width: 1440px) {
  .header-tag {
    font-size: 21px;
    font-weight: 500;
  }
  .buttons {
    float: right;
  }
}
@media screen and (min-width: 320px) and (max-width: 767px) {
  .viewdata-xs {
    display: flex !important;
    justify-content: center !important;
    margin-bottom: 5% !important;
  }
}
@media screen and (min-width: 1200px) and (max-width: 2560px) {
  .view-button {
    display: flex !important;
    justify-content: end !important;
  }
}
@media screen and (min-width: 320px) and (max-width: 2560px) {
  .viewdata-xs {
    margin-bottom: 5% !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/modules/patient.less"],"names":[],"mappings":"AAAA;;EAEE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,8BAA8B;EAC9B,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,aAAa;AACf;AACA;;;EAGE,WAAW;AACb;AACA;;;EAGE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,6BAA6B;AAC/B;AACA;EACE,8BAA8B;EAC9B,YAAY;AACd;AACA;EACE,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;AACA;EACE,UAAU;AACZ;AACA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,oBAAoB;AACtB;AACA;EACE,2BAA2B;EAC3B,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,uBAAuB;EACzB;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;IACX,cAAc;IACd,qBAAqB;EACvB;EACA;IACE,YAAY;EACd;EACA;IACE,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;AACF;AACA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,uBAAuB;EACzB;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;IACX,cAAc;IACd,qBAAqB;EACvB;EACA;IACE,WAAW;EACb;AACF;AACA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,uBAAuB;EACzB;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;IACX,cAAc;IACd,qBAAqB;EACvB;EACA;IACE,WAAW;EACb;AACF;AACA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,yBAAyB;EAC3B;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,kBAAkB;EACpB;EACA;IACE,aAAa;IACb,oCAAoC;EACtC;AACF;AACA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,yBAAyB;EAC3B;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;AACF;AACA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,wBAAwB;IACxB,kCAAkC;IAClC,4BAA4B;EAC9B;AACF;AACA;EACE;IACE,wBAAwB;IACxB,+BAA+B;EACjC;AACF;AACA;EACE;IACE,4BAA4B;EAC9B;AACF","sourcesContent":[".addnew-profile,\n.addnew-profile-couple {\n  padding: 5px;\n  width: 100px;\n  height: 100px;\n  border-radius: 50%;\n  text-align: center;\n}\n.Add-button {\n  justify-content: space-between;\n  margin: auto;\n}\n.ant-table-thead .ant-table-cell {\n  background-color: #0883b3;\n}\n.addnew-profile-image {\n  display: flex;\n  justify-content: center;\n}\n.form-label {\n  padding: 10px;\n}\nFF .select-width {\n  width: 100%;\n  padding: 10px;\n}\n.calender-responsive,\n.responsive-select,\n.register-input {\n  width: 100%;\n}\n.select-table-row,\n.button-tools,\n.search-button-table {\n  margin-top: 0.8rem;\n  margin-bottom: 0.8rem;\n}\n.Button-Tool {\n  display: flex;\n  justify-content: space-evenly;\n}\n.Header-row {\n  justify-content: space-between;\n  margin: auto;\n}\n.search-btn {\n  width: 80%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-left: 50px;\n  margin-top: 10px;\n}\n.register-button {\n  width: 98%;\n  display: flex;\n  justify-content: center;\n}\n.btn-cancel {\n  margin-right: 10px;\n}\n.csv-btn {\n  margin-top: -30px;\n}\n.button-row {\n  float: right;\n}\n.patient-edit-image {\n  width: 10%;\n}\n.view-patient-details {\n  font-size: medium;\n  padding: 1%;\n  font-weight: 300;\n}\n.view-patient-details-label {\n  font-size: medium;\n}\n.flex-end {\n  display: flex;\n  justify-content: end;\n}\n.view-header {\n  font-weight: 500 !important;\n  font-size: large !important;\n}\n.header-tag {\n  margin-bottom: 0 !important;\n}\n@media only screen and (min-width: 320px) {\n  .header-tag {\n    font-size: 21px;\n    font-weight: 500;\n  }\n  .addnew-button {\n    display: flex;\n    justify-content: center;\n  }\n  .search-button-table {\n    width: 100%;\n  }\n  .select-table-row {\n    width: 100%;\n  }\n  .search-btn {\n    width: 100%;\n    margin-left: 0;\n    margin-bottom: 0.8rem;\n  }\n  .button-edit {\n    padding: 3px;\n  }\n  .register-button {\n    margin-top: 16px;\n  }\n  .button-row {\n    width: 100%;\n  }\n}\n@media only screen and (min-width: 375px) {\n  .header-tag {\n    font-size: 21px;\n    font-weight: 500;\n  }\n  .addnew-button {\n    display: flex;\n    justify-content: center;\n  }\n  .search-button-table {\n    width: 100%;\n  }\n  .select-table-row {\n    width: 100%;\n  }\n  .search-btn {\n    width: 100%;\n    margin-left: 0;\n    margin-bottom: 0.8rem;\n  }\n  .button-row {\n    width: 100%;\n  }\n}\n@media only screen and (min-width: 425px) {\n  .header-tag {\n    font-size: 21px;\n    font-weight: 500;\n  }\n  .addnew-button {\n    display: flex;\n    justify-content: center;\n  }\n  .search-button-table {\n    width: 100%;\n  }\n  .select-table-row {\n    width: 100%;\n  }\n  .search-btn {\n    width: 100%;\n    margin-left: 0;\n    margin-bottom: 0.8rem;\n  }\n  .button-row {\n    width: 100%;\n  }\n}\n@media only screen and (min-width: 768px) {\n  .header-tag {\n    font-size: 21px;\n    font-weight: 500;\n  }\n  .addnew-button {\n    display: flex;\n    justify-content: flex-end;\n  }\n  .search-button-table {\n    width: 100%;\n  }\n  .select-table-row {\n    width: 50%;\n  }\n  .search-btn {\n    margin-top: 0.8rem;\n  }\n  .register-button {\n    display: flex;\n    justify-content: flex-end !important;\n  }\n}\n@media only screen and (min-width: 1024px) {\n  .header-tag {\n    font-size: 21px;\n    font-weight: 500;\n  }\n  .addnew-button {\n    display: flex;\n    justify-content: flex-end;\n  }\n  .select-table-row {\n    width: 60%;\n  }\n  .search-button-table {\n    width: 100%;\n  }\n}\n@media only screen and (min-width: 1440px) {\n  .header-tag {\n    font-size: 21px;\n    font-weight: 500;\n  }\n  .buttons {\n    float: right;\n  }\n}\n@media screen and (min-width: 320px) and (max-width: 767px) {\n  .viewdata-xs {\n    display: flex !important;\n    justify-content: center !important;\n    margin-bottom: 5% !important;\n  }\n}\n@media screen and (min-width: 1200px) and (max-width: 2560px) {\n  .view-button {\n    display: flex !important;\n    justify-content: end !important;\n  }\n}\n@media screen and (min-width: 320px) and (max-width: 2560px) {\n  .viewdata-xs {\n    margin-bottom: 5% !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
